<template>
  <div>
    <component
      v-for="param in listFilters"
      v-model="selectedFilters[param.query_param]"
      :key="param.query_param"
      :param="param"
      :is="getFilterComponent(param)"
    />
  </div>
</template>
<script>
import ChoiceFilter from './ChoiceFilter'
import DateFilter from './DateFilter'
import TextFilter from './TextFilter'

export default {
  props: {
    listFilters: Array,
    selectedFilters: Object
  },
  methods: {
    getFilterComponent(param) {
      if (param.options !== undefined) {
        return 'ChoiceFilter'
      } else if (param.date) {
        return 'DateFilter'
      }
      return 'TextFilter'
    }
  },
  components: {
    ChoiceFilter,
    DateFilter,
    TextFilter
  }
}
</script>
<style lang="scss" scoped>
.list-filter {
  margin: 25px 0;

  &-title {
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    color: #666666;
  }
}
</style>
